// extracted by mini-css-extract-plugin
export default {"inputComp":"Style_inputComp__HApCX","readOnlyClass":"Style_readOnlyClass__LLTZH","ErrorField":"Style_ErrorField__zYnID"};